const focusElementRefKeys = {
  activitiesListContainerHeading: "activitiesListContainerHeading",
  activitiesPanelHeader: "activitiesPanelHeader",
  activityPanelBackButton: "activityPanelBackButton",
  assignmentEditorHeading: "assignmentEditorHeading",
  bannerHomeButton: "bannerHomeButton",
  checkForUnderstandingQuizQuestion: "checkForUnderstandingQuizQuestion",
  pollContainer: "pollContainer",
  readAloudPlayPauseButton: "readAloudPlayPauseButton",
};

export default focusElementRefKeys;
